export function LoginFooter() {
  return (
    <footer className="w-full border-t border-gray-300 py-3 sm:py-4 px-4 sm:px-8">
      <div className="flex flex-col sm:flex-row items-center justify-center sm:justify-between text-xs text-grey mx-auto gap-2 sm:gap-0">
        <span className="text-center sm:text-left">
          Copyright ©2026 All Rights Reserved Zoracom
        </span>
        <div className="flex gap-4 sm:gap-6">
          <button className="hover:text-primary transition-colors">
            Terms
          </button>
          <button className="hover:text-primary transition-colors">
            Privacy Policy
          </button>
        </div>
      </div>
    </footer>
  );
}

export default LoginFooter;
